import React from 'react';
import PropTypes from 'prop-types';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function createCommonjsModule(fn) {
  var module = {
    exports: {}
  };
  return fn(module, module.exports), module.exports;
}
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/


var classnames = createCommonjsModule(function (module) {
  /* global define */
  (function () {
    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;
        var argType = typeof arg;

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg) && arg.length) {
          var inner = classNames.apply(null, arg);

          if (inner) {
            classes.push(inner);
          }
        } else if (argType === 'object') {
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }

      return classes.join(' ');
    }

    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
});
var _excluded = ["ref", "className", "to", "target", "children", "isInternal"],
    _excluded2 = ["className", "to", "target", "renderLink", "children"];
var LinkTarget = {
  _self: "_self",
  _blank: "_blank",
  _parent: "_parent",
  _top: "_top"
};

var defaultRenderLink = function defaultRenderLink(_ref) {
  var ref = _ref.ref,
      className = _ref.className,
      to = _ref.to,
      target = _ref.target,
      children = _ref.children,
      isInternal = _ref.isInternal,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement("a", _extends({
    ref: ref,
    href: to,
    target: target,
    className: classnames(className)
  }, props), children);
};

var Link = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
      to = _ref2.to,
      target = _ref2.target,
      renderLink = _ref2.renderLink,
      children = _ref2.children,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  var isInternal = /^(\/|#)(?!\/)/.test(to);
  return renderLink(_extends({
    ref: ref,
    to: to,
    target: target,
    className: className,
    isInternal: isInternal,
    children: children
  }, props));
});
Link.propTypes = {
  className: PropTypes.string,
  to: PropTypes.string.isRequired,
  target: PropTypes.oneOf(Object.keys(LinkTarget)),
  renderLink: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};
Link.defaultProps = {
  className: undefined,
  target: LinkTarget.self,
  renderLink: defaultRenderLink
};
var modules_e0508c7c = {
  "responsive": "Img_module_responsive__e0e919b3"
};
var _excluded$1 = ["renderImage"],
    _excluded2$1 = ["className", "wrapperClassName", "src", "source", "alt", "title", "autoResponsive"];

var Img = function Img(_ref) {
  var renderImage = _ref.renderImage,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  if (typeof renderImage === "function") {
    return renderImage({
      props: props
    });
  }

  var className = props.className,
      wrapperClassName = props.wrapperClassName,
      src = props.src,
      source = props.source,
      alt = props.alt,
      title = props.title,
      autoResponsive = props.autoResponsive,
      restProps = _objectWithoutPropertiesLoose(props, _excluded2$1);

  if (src) {
    return /*#__PURE__*/React.createElement("img", _extends({
      className: classnames(autoResponsive && modules_e0508c7c.responsive, wrapperClassName),
      src: src,
      alt: alt,
      title: title
    }, restProps));
  }

  if (source) {
    return /*#__PURE__*/React.createElement("picture", restProps, /*#__PURE__*/React.createElement("source", {
      srcSet: source.srcSet,
      sizes: source.sizes
    }), /*#__PURE__*/React.createElement("img", _extends({
      className: classnames(autoResponsive && modules_e0508c7c.responsive, wrapperClassName),
      src: source.src,
      srcSet: source.srcSet,
      sizes: source.sizes,
      alt: alt,
      title: title
    }, restProps)));
  }

  console.error("Img requires either src or source as a prop");
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};

Img.defaultProps = {
  className: undefined,
  wrapperClassName: undefined,
  src: undefined,
  source: undefined,
  title: undefined,
  autoResponsive: true,
  renderImage: undefined
};
var modules_876d2089 = {
  "container": "CardImage_module_container__940d82e6",
  "link": "CardImage_module_link__940d82e6",
  "image": "CardImage_module_image__940d82e6"
};
var _excluded$2 = ["className"],
    _excluded2$2 = ["wrapperClassName"];

var CardImage = function CardImage(_ref) {
  var className = _ref.className,
      imageClassName = _ref.imageClassName,
      alt = _ref.alt,
      src = _ref.src,
      source = _ref.source,
      clickable = _ref.clickable,
      autoResponsive = _ref.autoResponsive,
      ImageComponent = _ref.ImageComponent,
      providedImageComponentProps = _ref.imageComponentProps,
      LinkComponent = _ref.LinkComponent,
      providedLinkComponentProps = _ref.linkComponentProps,
      children = _ref.children;

  var providedLinkComponentClassName = providedLinkComponentProps.className,
      restLinkComponentProps = _objectWithoutPropertiesLoose(providedLinkComponentProps, _excluded$2);

  var linkComponentProps = _extends({
    className: classnames(modules_876d2089.link, providedLinkComponentClassName)
  }, clickable, restLinkComponentProps);

  var providedWrapperClassName = providedImageComponentProps.wrapperClassName,
      restImageComponentProps = _objectWithoutPropertiesLoose(providedImageComponentProps, _excluded2$2);

  var imageComponentProps = _extends({
    wrapperClassName: classnames(modules_876d2089.image, imageClassName, providedWrapperClassName),
    src: src,
    source: source,
    alt: alt,
    autoResponsive: autoResponsive
  }, restImageComponentProps);

  if (clickable) {
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(modules_876d2089.container, className)
    }, /*#__PURE__*/React.createElement(LinkComponent, linkComponentProps, /*#__PURE__*/React.createElement(ImageComponent, imageComponentProps)), children);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classnames(modules_876d2089.container, className)
  }, /*#__PURE__*/React.createElement(ImageComponent, imageComponentProps), children);
};

CardImage.displayName = "CardImage";
CardImage.defaultProps = {
  className: undefined,
  imageClassName: undefined,
  src: undefined,
  source: undefined,
  clickable: undefined,
  autoResponsive: true,
  ImageComponent: Img,
  imageComponentProps: {},
  LinkComponent: Link,
  linkComponentProps: {},
  children: undefined
};

var wrapWithRequired = function wrapWithRequired(validator, isRequired) {
  if (isRequired) {
    return {
      isRequired: validator
    };
  }

  return validator;
};

var _excluded$3 = ["id", "className", "style", "classNames", "as", "size", "weight", "align", "uppercase", "children"];
var HeadingAsElement = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  p: "p",
  span: "span",
  div: "div"
};

var Heading = function Heading(_ref) {
  var _cx;

  var id = _ref.id,
      className = _ref.className,
      style = _ref.style,
      classNames = _ref.classNames,
      as = _ref.as,
      size = _ref.size,
      weight = _ref.weight,
      align = _ref.align,
      uppercase = _ref.uppercase,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3);

  var Tag = "" + as;
  var classes = classnames((_cx = {}, _cx[classNames == null ? void 0 : classNames["heading--" + size]] = size && (classNames == null ? void 0 : classNames["heading--" + size]), _cx[classNames == null ? void 0 : classNames["heading--" + weight]] = weight && (classNames == null ? void 0 : classNames["heading--" + weight]), _cx[classNames == null ? void 0 : classNames["heading--" + align]] = align && (classNames == null ? void 0 : classNames["heading--" + align]), _cx[classNames == null ? void 0 : classNames["heading--uppercase"]] = uppercase && (classNames == null ? void 0 : classNames["heading--uppercase"]), _cx[className] = className, _cx));
  return /*#__PURE__*/React.createElement(Tag, _extends({
    className: classes,
    id: id
  }, props, {
    style: style
  }), children);
};

Heading.displayName = "Heading";
Heading.defaultProps = {
  id: undefined,
  className: undefined,
  style: undefined,
  as: HeadingAsElement.h1,
  size: undefined,
  weight: undefined,
  align: "left",
  uppercase: false,
  children: undefined
};
var _excluded$4 = ["style", "className", "classNames", "HeadingComponent", "as", "align", "uppercase", "size", "weight", "children"];

var CardHeader = function CardHeader(_ref) {
  var style = _ref.style,
      className = _ref.className,
      classNames = _ref.classNames,
      HeadingComponent = _ref.HeadingComponent,
      as = _ref.as,
      align = _ref.align,
      uppercase = _ref.uppercase,
      size = _ref.size,
      weight = _ref.weight,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4);

  return /*#__PURE__*/React.createElement(HeadingComponent, _extends({
    className: classnames(className),
    classNames: classNames,
    style: style,
    as: as,
    align: align,
    uppercase: uppercase,
    size: size,
    weight: weight
  }, props), children);
};

CardHeader.displayName = "CardHeader";
CardHeader.defaultProps = {
  className: undefined,
  classNames: undefined,
  style: {},
  HeadingComponent: Heading,
  as: HeadingAsElement.p,
  align: "left",
  uppercase: false,
  size: undefined,
  weight: undefined
};
var _excluded$5 = ["className", "classNames", "SubheadingComponent", "as", "align", "uppercase", "size", "weight", "children"];
var CardSubheaderAsElement = {
  h4: "h4",
  h5: "h5",
  p: "p",
  span: "span"
};

var CardSubheader = function CardSubheader(_ref) {
  var className = _ref.className,
      classNames = _ref.classNames,
      SubheadingComponent = _ref.SubheadingComponent,
      as = _ref.as,
      align = _ref.align,
      uppercase = _ref.uppercase,
      size = _ref.size,
      weight = _ref.weight,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$5);

  return /*#__PURE__*/React.createElement(SubheadingComponent, _extends({
    className: classnames(className),
    classNames: classNames,
    as: as,
    align: align,
    uppercase: uppercase,
    size: size,
    weight: weight
  }, props), children);
};

CardSubheader.displayName = "CardSubheader";
CardSubheader.defaultProps = {
  className: undefined,
  classNames: undefined,
  SubheadingComponent: Heading,
  as: CardSubheaderAsElement.p,
  align: "left",
  uppercase: false,
  size: undefined,
  weight: undefined
};
var _excluded$6 = ["className", "children"];

var CardBody = function CardBody(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$6);

  return /*#__PURE__*/React.createElement("div", _extends({
    className: classnames(className)
  }, props), children);
};

CardBody.displayName = "CardBody";
CardBody.defaultProps = {
  className: undefined
};
var _excluded$7 = ["className", "children"];

var CardContent = function CardContent(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$7);

  return /*#__PURE__*/React.createElement("div", _extends({
    className: classnames(className)
  }, props), children);
};

CardContent.displayName = "CardContent";
CardContent.defaultProps = {
  className: undefined
};
var _excluded$8 = ["className", "LinkComponent", "to", "target", "icon", "renderLink", "children"];

var CardLink = function CardLink(_ref) {
  var className = _ref.className,
      LinkComponent = _ref.LinkComponent,
      to = _ref.to,
      target = _ref.target,
      icon = _ref.icon,
      renderLink = _ref.renderLink,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$8);

  return /*#__PURE__*/React.createElement(LinkComponent, _extends({
    to: to,
    target: target,
    className: classnames(className),
    renderLink: renderLink
  }, props), children, icon && icon);
};

CardLink.displayName = "CardLink";
CardLink.defaultProps = {
  LinkComponent: Link,
  className: undefined,
  target: "_self",
  icon: undefined,
  renderLink: undefined,
  children: undefined
};
var modules_79b43374 = {
  "btn": "Button_module_btn__4440de1a",
  "btn--disabled": "Button_module_btn_Disabled__4440de1a",
  "btn--icon-left": "Button_module_btn_IconLeft__4440de1a",
  "btn--no-label": "Button_module_btn_NoLabel__4440de1a",
  "btn--icon": "Button_module_btn_Icon__4440de1a",
  "btn--icon-right": "Button_module_btn_IconRight__4440de1a",
  "btn--full": "Button_module_btn_Full__4440de1a"
};
var _excluded$9 = ["type", "className", "classNames", "defaultStyle", "noStyle", "label", "to", "target", "onClick", "icon", "iconPlacement", "disabled", "full", "LinkComponent", "linkComponentProps", "children"],
    _excluded2$3 = ["className"];
var ButtonType = {
  button: "button",
  submit: "submit",
  reset: "reset"
};
var ButtonLinkTarget = {
  _self: "_self",
  _blank: "_blank",
  _parent: "_parent",
  _top: "_top"
};
var ButtonIconPlacement = {
  left: "left",
  right: "right"
};
var defaultClassNames = {
  iconWrapper: modules_79b43374["btn--icon"]
};

var Button = function Button(_ref) {
  var _cx;

  var type = _ref.type,
      className = _ref.className,
      providedClassNames = _ref.classNames,
      defaultStyle = _ref.defaultStyle,
      noStyle = _ref.noStyle,
      label = _ref.label,
      to = _ref.to,
      target = _ref.target,
      onClick = _ref.onClick,
      icon = _ref.icon,
      iconPlacement = _ref.iconPlacement,
      disabled = _ref.disabled,
      full = _ref.full,
      LinkComponent = _ref.LinkComponent,
      providedLinkComponentProps = _ref.linkComponentProps,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$9);

  var classNames = _extends({}, defaultClassNames, providedClassNames);

  var _providedLinkComponen = providedLinkComponentProps.className,
      providedLinkComponentClassName = _providedLinkComponen === void 0 ? "" : _providedLinkComponen,
      restLinkComponentProps = _objectWithoutPropertiesLoose(providedLinkComponentProps, _excluded2$3);

  var linkComponentProps = _extends({
    to: to,
    target: target
  }, restLinkComponentProps);

  var noStyleClasses = classnames(className, providedLinkComponentClassName);
  var classes = classnames((_cx = {}, _cx[modules_79b43374.btn] = defaultStyle, _cx[modules_79b43374["btn--disabled"]] = disabled && modules_79b43374["btn--disabled"], _cx[modules_79b43374["btn--no-label"]] = !label && !children && modules_79b43374["btn--no-label"], _cx[modules_79b43374["btn--icon-" + iconPlacement]] = icon && iconPlacement && modules_79b43374["btn--icon-" + iconPlacement], _cx[modules_79b43374["btn--full"]] = full && modules_79b43374["btn--full"], _cx[noStyleClasses] = noStyleClasses, _cx)); // Check for empty onClick handlers

  if (to && typeof onClick !== "function") {
    return /*#__PURE__*/React.createElement(LinkComponent, _extends({
      className: classnames(noStyle ? noStyleClasses : classes)
    }, linkComponentProps), icon && iconPlacement === "left" && /*#__PURE__*/React.createElement("span", {
      className: classnames(classNames.iconWrapper)
    }, icon), children || label, icon && iconPlacement === "right" && /*#__PURE__*/React.createElement("span", {
      className: classnames(classNames.iconWrapper)
    }, icon));
  }

  return /*#__PURE__*/React.createElement("button", _extends({
    className: classnames(noStyle ? noStyleClasses : classes) // eslint-disable-next-line react/button-has-type
    ,
    type: type,
    "aria-label": label || children,
    disabled: disabled,
    onClick: onClick
  }, props), icon && iconPlacement === "left" && /*#__PURE__*/React.createElement("span", {
    className: classnames(classNames.iconWrapper)
  }, icon), children || label, icon && iconPlacement === "right" && /*#__PURE__*/React.createElement("span", {
    className: classnames(classNames.iconWrapper)
  }, icon));
};

Button.defaultProps = {
  className: undefined,
  classNames: defaultClassNames,
  type: ButtonType.button,
  label: undefined,
  to: undefined,
  target: ButtonLinkTarget._self,
  onClick: undefined,
  icon: undefined,
  iconPlacement: ButtonIconPlacement.left,
  disabled: false,
  full: false,
  noStyle: false,
  defaultStyle: true,
  LinkComponent: Link,
  linkComponentProps: {},
  children: undefined
};
var _excluded$a = ["className", "ButtonComponent", "to", "target", "onClick", "label", "icon", "iconPlacement", "children"];
var CardButtonLinkTarget = {
  _self: "_self",
  _blank: "_blank",
  _parent: "_parent",
  _top: "_top"
};

var CardButton = function CardButton(_ref) {
  var className = _ref.className,
      ButtonComponent = _ref.ButtonComponent,
      to = _ref.to,
      target = _ref.target,
      onClick = _ref.onClick,
      label = _ref.label,
      icon = _ref.icon,
      iconPlacement = _ref.iconPlacement,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$a);

  return /*#__PURE__*/React.createElement(ButtonComponent, _extends({
    className: className,
    to: to,
    target: target,
    onClick: onClick,
    label: label,
    icon: icon,
    iconPlacement: iconPlacement
  }, props), children);
};

CardButton.displayName = "CardButton";
CardButton.defaultProps = {
  className: undefined,
  ButtonComponent: Button,
  to: undefined,
  onClick: undefined,
  target: CardButtonLinkTarget._self,
  label: undefined,
  icon: undefined,
  iconPlacement: undefined
};
var modules_b00ad8e5 = {
  "overlay": "CardOverlay_module_overlay__1149943b"
};
var _excluded$b = ["className", "children"];

var CardOverlay = function CardOverlay(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$b);

  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    React.createElement("div", _extends({
      role: "dialog",
      className: classnames(modules_b00ad8e5.overlay, className),
      tabIndex: 0
    }, props), children)
  );
};

CardOverlay.displayName = "CardOverlay";
CardOverlay.defaultProps = {
  className: undefined
};
var modules_cf3bd172 = {
  "cardContainer": "Card_module_cardContainer__2b40feca"
};
var _excluded$c = ["children", "className"];

var Card = function Card(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$c);

  return /*#__PURE__*/React.createElement("div", _extends({
    className: classnames(modules_cf3bd172.cardContainer, className)
  }, props), children);
};

Card.displayName = "Card";
Card.Image = CardImage;
Card.Header = CardHeader;
Card.Subheader = CardSubheader;
Card.Overlay = CardOverlay;
Card.Content = CardContent;
Card.Link = CardLink;
Card.Button = CardButton;
Card.Body = CardBody;
Card.defaultProps = {
  className: undefined
};
export default Card;
export { Card };